import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { Col, Row } from "antd";
import { Contact } from "@type/core/dashboard/dashboard.types";
import { formatCategory } from "@utils/helpers/format-helper";

interface ContactInformationComparisonFormProps {
  contactToAdd?: Contact;
  existingContact?: Contact;
}

const ContactInformationComparisonForm: FunctionComponent<
  ContactInformationComparisonFormProps
> = ({ contactToAdd, existingContact }) => {
  const { t } = useTranslation();
  return (
    <>
      {t("contacts.confirmationContactModal.body")}
      <Row>
        <Col flex={2} className={"pl-0 pr-0 pb-2"}>
          <h2 className="text-left w-100 mb-0 pb-2 pt-1 text-primary">
            {t("contacts.confirmationContactModal.baseInformation")}
          </h2>
          {existingContact && (
            <>
              <Row className="w-100 ml-4">
                {t("contacts.confirmationContactModal.firstname")}{" "}
                {existingContact.firstname}
              </Row>
              <Row className="w-100 ml-4">
                {t("contacts.confirmationContactModal.lastname")}{" "}
                {existingContact.lastname}
              </Row>
              <Row className="w-100 ml-4">
                {t("contacts.confirmationContactModal.email")}{" "}
                {existingContact.email}
              </Row>
              <Row className="w-100 ml-4">
                {t("contacts.confirmationContactModal.phone")}{" "}
                {existingContact.phone}
              </Row>
              <Row className="w-100 ml-4 mb-1">
                {t("contacts.confirmationContactModal.companyName")}{" "}
                {existingContact.companyName}
              </Row>
              <Row className="w-100 ml-4 mb-1">
                <p className={"mr-2 mb-0"}>
                  {t("contacts.confirmationContactModal.category")}
                </p>{" "}
                {existingContact.category
                  ? formatCategory(existingContact.category)
                  : ""}
              </Row>
            </>
          )}
        </Col>
        <Col flex={1} className={"align-self-center text-center pr-0 pl-0"}>
          <div className={"coordinating"}>{t("common.or")}</div>
        </Col>
        {contactToAdd && (
          <>
            <Col flex={2} className={"pl-0 pr-0 pb-2"}>
              <h2 className="text-left mb-0 pb-2 pt-1 text-primary">
                {t("contacts.confirmationContactModal.inputInformation")}
              </h2>
              <Row className="w-100 ml-4">
                {t("contacts.confirmationContactModal.firstname")}{" "}
                {contactToAdd.firstname}
              </Row>
              <Row className="w-100 ml-4">
                {t("contacts.confirmationContactModal.lastname")}{" "}
                {contactToAdd.lastname}
              </Row>
              <Row className="w-100 ml-4">
                {t("contacts.confirmationContactModal.email")}{" "}
                {contactToAdd.email}
              </Row>
              <Row className="w-100 ml-4">
                {t("contacts.confirmationContactModal.phone")}{" "}
                {contactToAdd.phone}
              </Row>
              <Row className="w-100 ml-4 mb-1">
                {t("contacts.confirmationContactModal.companyName")}{" "}
                {contactToAdd.companyName}
              </Row>
              <Row className="w-100 ml-4 mb-1">
                <p className={"mr-2 mb-0"}>
                  {t("contacts.confirmationContactModal.category")}
                </p>{" "}
                {contactToAdd.category
                  ? formatCategory(contactToAdd.category)
                  : ""}
              </Row>
            </Col>
          </>
        )}
      </Row>
    </>
  );
};

export default ContactInformationComparisonForm;
